import React from 'react';
import {Alert, Link} from '@mui/material';
import {NavLink} from "react-router-dom";
import {AppPages, usePageUrl} from "../../app-layout/AppPages";

export function DeprecationWarning({children}: { children: React.ReactNode }) {
    return (
        <Alert severity="warning" sx={{mb: 2}}>
            {children}
        </Alert>
    );
}

export function KeyOperationDeprecationWarning() {
    const pageUrl = usePageUrl();
    return (
        <DeprecationWarning>
            This page is deprecated. Please use <Link
            component={NavLink}
            to={pageUrl(AppPages.keyTransactions)}
            color="warning"
            sx={{fontWeight: 600}}
        >Key Operations</Link> instead.
        </DeprecationWarning>
    );
}